var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#help';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-help';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?help#help';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?help#view-help';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };